export default "__VITE_ASSET__C9yXQKjA__"